module.exports = __webpack_public_path__ + "fonts/CalibreThin.d262219b.woff";